import { Component, OnInit, ViewEncapsulation, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AmplifyService } from 'aws-amplify-angular';
import { AuthenticationService } from '../_services/authentication.service';
import { ProductoService } from '../_services/producto.service';
import { RecaptchaComponent } from 'ng-recaptcha';
import { RequiredIf } from '../_helpers/requiredIf';
import { HandleRetryService } from '../_services/handle-retry.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  @ViewChild('captchaRef') captcha: RecaptchaComponent;
  loginForm: FormGroup;
  hiddenUserNotExist = true;
  hiddenUserWrongPortal = true;
  hiddenUserCompanyNotFound = true;
  hiddenUserFederateAccount = true;
  hiddenError = true;
  mensajeError: String;
  loggedIn: boolean;
  user: any;
  returnUrl: string;
  signedIn: boolean;
  password: string;
  idAplicacion: string;
  redirectUrl: string;
  filtroAdicional: string;
  formDisabled = false;
  captchaOk = true;
  mostrarCaptcha = false;

  constructor(private router: Router,
    private authenticationService: AuthenticationService,
    private fb: FormBuilder,
    private amplifyService: AmplifyService,
    private activatedRoute: ActivatedRoute,
    private productoService: ProductoService,
    private handleRetryService: HandleRetryService
  ) { }

  ngOnInit(): void {
    // this.authenticationService.logoutRegister();
    this.activatedRoute.queryParams.subscribe(params => {
      this.idAplicacion = this.activatedRoute.snapshot.paramMap.get('idAplicacion');
      this.redirectUrl = params.redirectUrl == undefined ? '' : params.redirectUrl;
      this.filtroAdicional = params.filtroAdicional == undefined ? '' : params.filtroAdicional;
      this.productoService.setCurrentApp(this.idAplicacion);
      this.productoService.setLoginParams(this.idAplicacion, this.filtroAdicional, this.redirectUrl);
    });

    this.loginForm = this.fb.group({
      txtUsername: ['', [Validators.required, Validators.email]],
      txtPassword: ['', [Validators.required, Validators.minLength(6)]],
      captcha: ['', []],
      validarCaptcha: ['', []],
    }, {
      validator: [
        RequiredIf('captcha', 'validarCaptcha'),
      ]
    });
    if (this.authenticationService.isUserLogedIn()) {
      this.router.navigate(['/redirect', this.idAplicacion], {
        queryParams:
        {
          filtroAdicional: this.filtroAdicional,
          redirectUrl: this.redirectUrl
        }
      });
    }
  }

  onNormalLogin() {
    this.hiddenError = true;
    this.formDisabled = true;
    this.onLogin(this.loginForm.value.txtUsername, this.loginForm.value.txtPassword);
  }

  onLogin(username: string, password: string) {
    this.mensajeError = "";
    this.authenticationService.login(username, password, this.idAplicacion, this.filtroAdicional)
      .subscribe(data => {
        this.mostrarCaptcha = this.handleRetryService.clear("Login");
        this.authenticationService.redirectUsuarioLogeado(data, this.redirectUrl);
      },
        error => {
          this.formDisabled = false;
          this.hiddenError = false;
          switch (error.status) {
            case 401:
              this.mensajeError = 'Usuario o contraseña incorrecta';
              this.mostrarCaptcha = this.handleRetryService.addTryOrBlock("Login");
              break;
            case 409:
              var codigo = error.error.split("@")[0];
              var session = error.error.split("@")[1];
              if (
                this.authenticationService.validarRespuestaUsuario(codigo, session, username, password,
                  this.idAplicacion, this.redirectUrl, this.filtroAdicional)) {
                this.mensajeError = error.error;
              }
              this.hiddenError = true;
              break;
            default:
              this.mensajeError = 'Ha ocurrido un error inesperado, favor intente nuevamente más tarde.';
          }
          if (this.captcha)
            this.captcha.reset();
        });
  }

  onClickPassword() {
    this.router.navigate(["/forgotpassword"]);
  }

  socialSignIn() {
    const amplifyAuth: any = this.amplifyService.auth();
    amplifyAuth.federatedSignIn({
      provider: 'Google'
    });
  }

  signInEmpresa(){
    const amplifyAuth: any = this.amplifyService.auth();
    amplifyAuth.federatedSignIn({
      provider: 'office365'
    });
  }
}
